export default {
  /**
   * Pings a url.
   * @param  {String} url
   * @param  {Number} multiplier - optional, factor to adjust the ping by.  0.3 works well for HTTP servers.
   * @return {Promise} promise that resolves to a ping (ms, float).
   */
  url(url, multiplier) {
    return new Promise(function(resolve, reject) {
      let start = (new Date()).getTime()
      let response = function() {
        let delta = ((new Date()).getTime() - start)
        delta *= (multiplier || 1)
        resolve(delta)
      }
      requestImage(url).then(response).catch(response)

      // Set a timeout for max-pings, 5s.
      setTimeout(function() { reject(Error('Timeout')) }, 5000)
    })
  }
}

let requestImage = (url) => {
  return new Promise(function(resolve, reject) {
    let img = new Image()
    img.onload = function() { resolve(img) }
    img.onerror = function() { reject(url) }
    img.src = url + '?random-no-cache=' + Math.floor((1 + Math.random()) * 0x10000).toString(16)
  })
}
